@if (showHeading) {
  <h3 class="text-uppercase fw-bold h5" data-test-id="app-auto-vision-seller-location-e-header">{{autoVisionSellerLocation.sellerAndLocation}}</h3>
}
@if (location$ | async; as location) {
  <section class="vehicle-location" [class.mb-5]="showHeading">
    <p
      class="vehicle-location__seller-name m-0 fw-bold">
      {{ location.sellerName }}
    </p>
    @if (isSellerLocationAvailable(location)) {
      <p
        class="vehicle-location__seller-name m-0 fw-bold"
        >
        {{this.autoVisionSellerLocation.notAvailable}}
      </p>
    }
    <div class="vehicle-location__storage mt-3">
      <p class="vehicle-location__storage--title text-uppercase fw-bold mb-1">{{autoVisionSellerLocation.vehicleLocation}}</p>
      <div class="vehicle-location__storage--info">
        @if (isLocationAvailable(location)) {
          <p
            class="mb-0"
            >
            {{this.autoVisionSellerLocation.notAvailable}}
          </p>
        }
        @if (location.name) {
          <p class="mb-0">{{ location.name }}</p>
        }
        @if (location.addressLine1) {
          <p class="mb-0">{{ location.addressLine1 }}</p>
        }
        @if (location.addressLine2) {
          <p class="mb-0">{{ location.addressLine2 }}</p>
        }
        @if (location.city) {
          <p class="mb-0 d-inline-block">
            {{ location.city }}
            @if (location.city) {
              ,
            }
            &nbsp;
          </p>
        }
        @if (location.state) {
          <p class="mb-0 d-inline-block">{{ location.state }} &nbsp;</p>
        }
        @if (location.zip) {
          <p class="mb-0 d-inline-block">{{ location.zip }}</p>
        }
      </div>
    </div>
  </section>
}
